export const AUTO_HIDE_DURATION = 6000;
export const ANCHOR_HORIZONTAL = "left";
export const ANCHOR_VERTICAL = "bottom";
export const EMPTY_STRING = "";
export const SNACK_BAR_ARIAL_COLOR = "inherit";
export const SNACK_BAR_ARIAL_LABEL = "Close";
export const SNACK_BAR_ICON_KEY = "close";
export const SNACK_BAR_PROPERTY = "aria-describedby";
export const SNACK_BAR_VALUE = "message-id";
